import { useState } from "react";
import clsx from "clsx";

// Material
import { Divider, Typography, Box, Stack, MenuList } from "@mui/material";

// Hooks
import { useNotificationInfo, useNotificationMutations } from "@/Common/hooks/Notifications";
import { useWrapperLayer } from "@/Common/context/wrapperLayer/WrapperLayerContext";

// Components
import { NotificationList } from "@/Layouts/views/Header/components/Notifications/NotificationList";
import CustomizedSwitch from "@/Layouts/components/InputComponents/CustomizedSwitches";

export const NotificationsMenu = () => {
	const [showOnlyUnread, setShowOnlyUnread] = useState(true);

	const { isDisabled } = useWrapperLayer();
	const { notificationInfo } = useNotificationInfo();
	const { updateNewNotification, updateAllNotification } = useNotificationMutations();

	const onMouseEnter = () => {
		notificationInfo?.newCount && updateNewNotification();
	};

	const onMouseLeave = () => {
		notificationInfo?.newCount && updateNewNotification();
	};

	const maskAllAssRead = () => {
		updateAllNotification();
	};

	if (isDisabled) {
		return null;
	}

	return (
		<MenuList
			className="max-h-[510px] !w-[400px] !rounded-b-[10px] !pt-0 pb-[10px]"
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<Stack direction="row" justifyContent="space-between" className="py-[14px] px-4">
				<Stack>
					<Box className="h-6 text-default font-medium font-montserrat text-lg">Notifications</Box>
					<Typography
						onClick={maskAllAssRead}
						className={clsx("!font-montserrat !text-[11px] text-default/60 hover:text-default hover:underline cursor-pointer", {
							hidden: notificationInfo?.unreadCount === 0,
						})}
					>
						Mark all as read
					</Typography>
				</Stack>
				{/* TODO: Change the CustomizedSwitch implementation to accept classes, allowing us to remove the `switch-notifications` class */}
				<Box className="switch-notifications pr-[2px]">
					<CustomizedSwitch
						IOSxs
						checked={showOnlyUnread}
						onChange={setShowOnlyUnread}
						textChecked={"Only show unread"}
						textUnChecked={"Only show unread"}
					/>
				</Box>
			</Stack>
			<Divider />
			<NotificationList showOnlyUnread={showOnlyUnread} />
		</MenuList>
	);
};
